import React, {useEffect, useRef, useState} from "react";
import readConfig from "../../../utils/readClientConfiguration";
import productionConfiguration from '../../../config/default.json';
import './Gls.scss';

const Map = ({ setPoint }) => {
    const glsConfig = readConfig(productionConfiguration, 'gls');
    const glsMapRef = useRef();

    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'module';
        script.src = glsConfig.url;
        document.head.appendChild(script);

        const handleChange = (e) => {
            setPoint(e.detail);
        };

        glsMapRef.current.addEventListener('change', handleChange);

        return () => {
            if (glsMapRef.current) {
                glsMapRef.current.removeEventListener('change', handleChange);
            }
        };
    }, []);


    return (
        <div id='glsMapPopup'>
            <gls-dpm country={glsConfig.lang} id="gls-map" ref={glsMapRef}></gls-dpm>
        </div>
    )
}

export default Map